<template>
  <section class="post-info-section">
    <div class="details">
      <span class="campaign-title">Series name goes here</span>
      <h2>{{ deliverableDetail.title }}</h2>
      <hr />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import SocialSeriesDialog from "./SocialSeriesDialog.vue";

export default {
  data() {
    return {
      
    };
  },
  components: {
    SocialSeriesDialog,
  },
  props: ["socialPost"],
  
  computed: {
    ...mapGetters([
      "deliverableDetail",
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    dummyFunction() {
    	return "";
    },
  }
}

</script>